import React, { useContext } from 'react'
import cx from 'classnames'
import ReactFocusLock from 'react-focus-lock'
import { useAppSelector } from 'reduxTyped'

import { LayoutContext } from 'apps/aiAutomation/components/Layout/lib/context'
import { AiAutomationLayoutSelectors } from 'apps/aiAutomation/store/layout'

import cm from './Sidebar.module.css'

interface SidebarProps {
  children: React.ReactNode
}

export const Sidebar = ({ children }: SidebarProps) => {
  const isSidebarOpen = useAppSelector(AiAutomationLayoutSelectors.getIsSidebarOpen)
  const isConfirmOpen = useAppSelector(AiAutomationLayoutSelectors.getIsConfirmOpen)
  const isSidebarExpanded = useAppSelector(AiAutomationLayoutSelectors.getIsSidebarExpanded)
  const interactiveView = useAppSelector(AiAutomationLayoutSelectors.getInteractiveView)

  const { sidebarRef } = useContext(LayoutContext)

  return (
    <ReactFocusLock
      disabled={!isSidebarOpen || isConfirmOpen}
      returnFocus
      autoFocus={Boolean(interactiveView)}
    >
      <aside
        ref={sidebarRef}
        className={cx(cm.layoutSidebar, isSidebarExpanded && cm.layoutSidebar__expanded)}
        aria-hidden={!isSidebarOpen}
      >
        <div className={cm.sidebar}>{children}</div>
      </aside>
    </ReactFocusLock>
  )
}
